import SHA256 from "crypto-js/sha256";

const sortObject = (obj) => {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }
  const sortedKeys = Object.keys(obj).sort();
  const result = {};
  sortedKeys.forEach((key) => {
    result[key] = sortObject(obj[key]);
  });
  return result;
};


export const computeChecksum = (data) => {
  const sortedData = sortObject(data);
  const dataString = JSON.stringify(sortedData);
  console.log("Client data string:", dataString);
  return SHA256(dataString).toString();
};
